import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useIntl } from 'react-intl';
import { useForm, Controller } from 'react-hook-form';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ReCaptcha from '../../common/form/recaptcha/ReCaptcha';
import PhoneNumberInput from '../../../lib/inputs/PhoneNumberInput';
import { INPUT_TYPES } from '../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../constants/inputs/validationTypes';

// Components
import { GIButton } from 'app-components';

type FormValues = {
    phonenumber: string
    lastname: string
    captcha: string
}
  

const ForgotEmail = (props) => {

    const {
        onSubmit,
        environment: {
            accessCodeExpandedViewEnabled,
            hideCaptcha,
            properties: {
                RECAPTCHA_SITE_KEY
            },
            language
        }
    } = props;

    const intlApi = useIntl();

    const { clearErrors, control, setValue, setError, register, handleSubmit, formState: { errors, isSubmitted }  } = useForm<FormValues>({ defaultValues:{} });

    // Note : Future we will move this duplicate code and recaptcha component to app-components
    const reCaptchaWrapperExpandedViewEnabledClass = 'desktop:grid-col-8 tablet:grid-col-8 mobile:grid-col-8 grid-col-6 margin-tb-10';
    const reCaptchaWrapperNonExpandedViewEnabledClass = 'desktop:grid-col-8 tablet:grid-col-8 mobile:grid-col-8 grid-col-6 margin-b-20';
    const reCaptchaWrapperClass = accessCodeExpandedViewEnabled ? reCaptchaWrapperExpandedViewEnabledClass : reCaptchaWrapperNonExpandedViewEnabledClass;

    const setCaptchaValue = (value) => {
        setValue('captcha', value);
        clearErrors('captcha');
    };

    const handlePhoneChange = (value) => {
        setValue('phonenumber', value);
        if(isSubmitted){
            value ?  clearErrors('phonenumber') : setError("phonenumber", { type: "focus" }, { shouldFocus: true });
        }
    }

    return (
        <Fragment>
            <form
                className="grid-col-12"
                onSubmit={handleSubmit(onSubmit)}
            >
                <Controller
                 name="phonenumber"
                 control={control}
                 rules={{ required: true }}
                    render={() => (
                        <PhoneNumberInput
                            label={{
                                text: intlApi.formatMessage({ id: 'anonymous.forgot_email.label.phoneNumber' }),
                                labelClasses: ['gi-regular_input__label', 'gi-input']
                            }}
                            inputData={{
                                id:'forgotemail_num',
                                isInputRequired: false,
                                type: INPUT_TYPES.PHONE_NUMBER_INPUT,
                                helperClasses: [],
                                name:"phonenumber",
                                value: '',
                                placeholder: '(xxx) xxx-xxxx',
                                validationType: VALIDATION_TYPES.PHONE_NUMBER,
                                currentData: '',
                                fields: [],
                            }}
                            inputActions={{
                                handleFieldChange: handlePhoneChange,
                            }}
                        />
                    )}       
                />
                <div className='tablet:grid-offset-4'>
                    {(errors.phonenumber) && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.label.phoneNumber.patteren' /></p>}
                </div>
                <div className="grid-row gi-component gi-regular_input">
                    <label htmlFor="forgotemail_lastname" className="tablet:grid-col-4 gi-regular_input__label gi-input ticket-form__label">
                        <FormattedMessage id='anonymous.forgot_email.label.lastName' />
                    </label>
                    <input
                        id='forgotemail_lastname'
                        data-testid='forgotemail_lastname'
                        type='text'
                        className={'tablet:grid-col-6 gi-regular_input__input'}
                        {...register('lastname', { required: true })}
                    />
                    <div className='tablet:grid-offset-4'>
                    {errors.lastname && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.label.lastName.required' /></p>}
                    </div>
                </div>
                { !hideCaptcha &&
                    <div className="grid-row">
                        <div className='tablet:grid-offset-4'>
                            <Controller
                                render={() => (
                                    <ReCaptcha
                                        //sitekey='6Le00O8UAAAAAPTFoCZLD6QUsUU2XWjucFSpWcv0'
                                        sitekey={ RECAPTCHA_SITE_KEY }
                                        key={language}
                                        lang={language}
                                        onValidated={undefined}
                                        setCaptchaValue={setCaptchaValue}
                                        outerClass={['center']}
                                        wrapperClass={[reCaptchaWrapperClass]}
                                    />
                                )}
                                name="captcha"
                                control={control}
                                rules={{ required: true }}
                            />
                        </div>
                    </div>
                }
                {!hideCaptcha && errors.captcha &&
                    <div className="grid-row">
                        <div className='tablet:grid-offset-4'>
                            <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.label.confirmYourAreNotARobot' /></p>
                        </div>
                    </div>
                }
                <div className="grid-row controls-container">
                    <div className='tablet:grid-offset-4 mobile:grid-col-12'>
                        <GIButton id='updateNewTicketCategory' labelId={'anonymous.forgot_email.submit'} onClickHandler={handleSubmit(onSubmit)} />
                    </div>
                </div>
            </form>
        </Fragment>
    );
};

export default ForgotEmail;